import { getFormattedDate } from '../../utils/utilities';
import React from 'react';
import { HistoryFeesAmount } from './HistoryFeesAmount';
import { IHistoryFeesData } from '../../interfaces/merchant';

export const HistoryFeesTableRow = (props: IHistoryFeesData): JSX.Element => {
	const { date, amount, name } = props;

	return (
		<tr>
			<td>
				<div className="w-100px">
					{getFormattedDate(date, 'yyyy-MM-dd')}
				</div>
			</td>
			<td>
				<div className="w-100px">
					{name}
				</div>
			</td>
			<td>
				<HistoryFeesAmount amount={amount} name={name}/>
			</td>
		</tr>
	);
};
